import * as React from 'react';
import { ParagraphWidget } from '../forms/ParagraphWidget';
import { Btn, ButtonType, ButtonWidget } from '../buttons/ButtonWidget';
import { styled } from '../../theme';
import { DialogContentWidget } from './DialogContentWidget';
import { GroupedButtons } from '../buttons/GroupedButtons';

export interface ConfirmDialogProps {
  title?: string;
  subTitle?: string;
  message: string | JSX.Element;
  onConfirm?: () => any;
  onCancel?: () => any;
  isInfoDialog?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = (props) => {
  let btns: Btn[] = [
    {
      label: 'Cancel',
      type: ButtonType.TERTIARY,
      action: () => {
        props.onCancel?.();
      }
    },
    {
      label: 'Confirm',
      type: ButtonType.SECONDARY,
      action: () => {
        props.onConfirm?.();
      }
    }
  ];

  if (props.isInfoDialog) {
    btns = [
      {
        label: 'Ok',
        type: ButtonType.PRIMARY,
        action: () => {
          props.onConfirm?.();
        }
      }
    ];
  }

  return (
    <DialogContentWidget
      title={props.title}
      subTitle={props.subTitle}
      isErrorDialog={true}
      footerContent={<GroupedButtons btns={btns} />}
    >
      <S.Par>{props.message}</S.Par>
    </DialogContentWidget>
  );
};

const BASE_LABEL = 'error-dialog';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    display: flex;
    flex-direction: column;
    min-width: 200px;
  `;

  export const Par = styled(ParagraphWidget)`
    text-align: left;
  `;

  export const Button = styled(ButtonWidget)`
    min-width: 80px;
  `;
}
